<template>
    <b-overlay
        :show="showLoader"
        variant="dark"
        spinner-type="grow"
        class="overlay-wrapper"
        blur="0.5em"
    >
        <template #overlay>
            <img class="morula" src="/static/loader.gif" alt="loading" />
        </template>

        <router-view />

        <modals ref="modalPanels" />
    </b-overlay>
</template>

<script>
import { mapState } from 'vuex'
import Modals from './views/components/ModalPanels'
import '@videojs/themes/dist/sea/index.css'
import 'bootstrap-slider/dist/css/bootstrap-slider.css'
import 'password-strength-meter/dist/password.min.css'

export default {
    name: 'App',
    components: { Modals },
    computed: {
        ...mapState({
            showLoader: state => state.common.showLoader
        })
    }
}
</script>

<style lang="scss" scoped>
.overlay-wrapper {
    @include prevent-select();
    height: 100%;

    .morula {
        height: 50px;
        width: 50px;
    }
}
</style>
